import { OtherInstructions } from '@bb/domain/dist/types';
import AppointmentConfigDefault from '@bb/domain/dist/types/AppointmentConfigDefault';
import { ModalFuncProps } from 'antd';
import React from 'react';

export const BREAKPOINTS = {
  sm: '768px',
  md: '992px',
  lg: '1200px',
};

export const BREAKPOINTS_INT = {
  sm: 768,
  md: 992,
  lg: 1200,
};

export const countries = [
  { label: 'Canada', value: 'CAN' },
  { label: 'USA', value: 'USA' },
];

export type BreakPoints = 'sm' | 'md' | 'lg';

export const DEFAULT_AVATAR =
  'https://cdn.filestackcontent.com/yWwQq12yR2a8pUdwujYB';

export const AVATAR_TYPES = {
  profile: 300,
  chat: 75,
};

export const FALLBACK_LISTING_THUMBNAIL =
  'https://cdn.filestackcontent.com/jTK5nGAhTJKQ7ubSmOjS';

export const FILESTACK_API_KEY = 'AVsLFCmooSeCfsjDRz3Cbz';

export const APPOINTMENT_STATUS_FOR_COVID_19_LABEL = [
  'new',
  'attempted',
  'confirm',
  'time_change',
];

export const UNVERIFIED_AGENT_MODAL: ModalFuncProps = {
  title: (
    <span data-cy="unverifiedAgentModal-title">
      Your account hasn&apos;t been verified yet
    </span>
  ),
  content: (
    <>
      <span data-cy="unverifiedAgentModal-explanation">
        You cannot book showings or register offers for yourself as your agent
        member ID does not appear to be associated with your brokerage. If you
        recently transferred brokerages, it may take 24-48 hours to become
        verified.
      </span>
      <br />
      <br />
      <span data-cy="unverifiedAgentModal-note">
        Please contact your brokerage admin to troubleshoot this issue.
      </span>
    </>
  ),
  centered: true,
  okButtonProps: {
    // @ts-expect-error button props don't recognize data-* attributes as valid props
    'data-cy': 'unverifiedAgentModal-button',
  },
};

export const UNVERIFIED_ADMIN_MODAL: ModalFuncProps = {
  title: (
    <span data-cy="unverifiedAdminModal-title">
      Your account hasn&apos;t been verified yet
    </span>
  ),
  content: (
    <>
      <span data-cy="unverifiedAdminModal-explanation">
        You can only book showings / register offers on behalf of other agents
        as your agent member ID does not appear to be associated with your
        brokerage. If you recently transferred brokerages, it may take 24-48
        hours to become verified.
      </span>
      <br />
      <br />
      <span data-cy="unverifiedAdminModal-note">
        Please contact your brokerage admin to troubleshoot this issue.
      </span>
    </>
  ),
  centered: true,
  okButtonProps: {
    // @ts-expect-error button props don't recognize data-* attributes as valid props
    'data-cy': 'unverifiedAdminModal-button',
  },
};

export const UNCLAIMED_LISTING_SWAL: SweetAlert.Settings &
  SweetAlert.AlertModalSettings = {
  title: 'Unclaimed Listing.',
  text: 'This listing is unclaimed and not represented by BrokerBay.',
  type: 'warning',
};

export const NA_TYPE_MAP = {
  Appraisal: 'Appraiser',
  Photographer: 'Photographer',
  'Pest Control': 'Pest Control',
  'Home Inspection': 'Home Inspector',
  'Buyer/Broker': 'Showing Agent',
  'Buyer Visit': 'Showing Agent',
  'Agent Inspection': 'Showing Agent',
  Revisit: 'Showing Agent',
  'Dual Agency': 'Showing Agent',
};

export const SUPRA_EKEY_LINK = 'https://ekey.suprakim.com/key';
export const SUPRA_LOGO_URL =
  'https://cdn.filestackcontent.com/bZ5Fp2JQ9qqO3QLPZn9Q';
export interface ApproveShowingOption {
  label: string;
  value: 'contactsToConfirm' | 'autoConfirm' | 'listingAgentConfirm';
  dataCy: 'contacts' | 'auto' | 'la';
}

export interface MaxShowingDurationOption {
  label: string;
  value: AppointmentConfigDefault['maxDuration'];
}

export const approveShowingsOptions: Array<ApproveShowingOption> = [
  {
    label: 'Seller / Contacts to Confirm',
    value: 'contactsToConfirm',
    dataCy: 'contacts',
  },
  {
    label: 'Auto-Confirm All Showings',
    value: 'autoConfirm',
    dataCy: 'auto',
  },
  {
    label: 'Listing Agent to Confirm',
    value: 'listingAgentConfirm',
    dataCy: 'la',
  },
];

export const maxShowingDurationOptions: Array<MaxShowingDurationOption> = [
  { label: '15 min', value: 15 },
  { label: '30 min', value: 30 },
  { label: '1 hr', value: 60 },
];

export const overlapOptions = [
  { label: 'No Limit', value: -1 },
  ...Array(4)
    .fill(0)
    .map((_, i) => ({
      label: `Max ${i + 2} overlapping showings`,
      value: i + 2,
    })),
];

export const bufferOptions = [
  { label: 'No buffer between showings', value: 0 },
  { label: '15 min buffer between showings', value: 1 },
  { label: '30 min buffer between showings', value: 2 },
  { label: '1 hour buffer between showings', value: 4 },
  { label: '2 hour buffer between showings', value: 8 },
];

export const showingAgentInstructionsOptions: {
  label: string;
  value: OtherInstructions;
}[] = [
  {
    label: 'Turn Off Lights',
    value: 'lights',
  },
  {
    label: 'Remove Shoes',
    value: 'shoes',
  },
  {
    label: 'Leave Card',
    value: 'card',
  },
  {
    label: 'Lock Doors',
    value: 'lock_doors',
  },
  {
    label: 'Knock First',
    value: 'knockFirst',
  },
  {
    label: 'Call if Late or Cancelling',
    value: 'callIfLate',
  },
  {
    label: 'Bring Agent License',
    value: 'reco',
  },
];
